import React from 'react'
import { BrandMark } from '../components/elements'
import { useTranslation } from 'react-i18next'

const StartScreen: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col justify-center items-center p-7 w-full bg-page">
      <BrandMark classes="text-5xl" />
      <span className="text-xl font-medium mt-4 text-foreground">{t('loadingIntercom')}</span>
      <div className="relative flex justify-center items-center w-10 h-10 mt-6">
        <div className="w-10 h-10 rounded-full border-4 border-accent border-t-primary animate-spin" />
      </div>
    </div>
  )
}

export default StartScreen
